import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SelectButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  width: 100%;
  height: 56px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 19px;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid #EDEDED;

  &:hover {
    background-color: #F7F7F7;
  }

  & > div {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #333333;
  }
`;
